module.exports = {"attributes":{"width":"20px","height":"11px","viewBox":"0 0 20 11","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g stroke=\"none\" stroke-width=\"1\">         <rect x=\"0\" y=\"0\" width=\"20\" height=\"2\"></rect>         <rect x=\"3\" y=\"3\" width=\"14\" height=\"2\"></rect>         <rect x=\"7\" y=\"6\" width=\"6\" height=\"2\"></rect>         <rect x=\"9\" y=\"9\" width=\"2\" height=\"2\"></rect>     </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/funnel.svg
// module id = 1412
// module chunks = 0